import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import type { TFunction } from "i18next";
import english from "./locales/en/search";

/** Metadata IDs remain behavior keys; descriptions are display-only. */
export function searchDescription(id: string, fallback: string, t: TFunction<"search">): string {
  if (!Object.prototype.hasOwnProperty.call(english, id)) return fallback;
  const key = id as keyof typeof english;
  return t($ => $[key]);
}

export function useSearchDescription() {
  const { t } = useTranslation("search");
  return useCallback((id: string, fallback: string) => searchDescription(id, fallback, t), [t]);
}
